import type {Result, UseCase} from 'framework';
import type {BodyMetric} from '../../domain/body-metric';
import type {BodyMeasurementsError} from '../../domain/errors';
import type {BodyMeasurementsRepository} from '../ports/body-measurements.repository';

export type CreateBodyMetricInput = {
  readonly name: string;
};

export class CreateBodyMetric implements UseCase<[CreateBodyMetricInput], BodyMetric> {
  constructor(private readonly repository: BodyMeasurementsRepository) {}

  execute(input: CreateBodyMetricInput): Promise<Result<BodyMetric, BodyMeasurementsError>> {
    return this.repository.createMetric(input.name);
  }
}
